import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <div className={`${styles.footer} container`}>
      <div className={styles.social}>
        <a href="https://github.com/Siqueira2" target="_blank" rel="noreferrer">
          <i className="uil uil-github-alt"></i>
        </a>
        <a
          href="https://www.behance.net/guilhersiqueir3"
          target="_blank"
          rel="noreferrer"
        >
          <i className="uil uil-behance"></i>
        </a>
        <a
          href="https://api.whatsapp.com/send/?phone=5531975263254&text&type=phone_number&app_absent=0"
          target="_blank"
          rel="noreferrer"
        >
          <i className="uil uil-whatsapp"></i>
        </a>
        <a
          href="https://www.linkedin.com/in/guilherme-siqueira-98aa54254"
          target="_blank"
          rel="noreferrer"
        >
          <i className="fa-brands fa-linkedin-in"></i>
        </a>
      </div>
      <p>Portfólio Guilherme Siqueira</p>
    </div>
  );
};

export default Footer;
